import { render, staticRenderFns } from "./SongwriterEditForm.vue?vue&type=template&id=a5d53746"
import script from "./SongwriterEditForm.vue?vue&type=script&lang=js"
export * from "./SongwriterEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports